import axios from 'axios';
import apiPaths from '../api-paths.js';

export default {
  show(id) {
    return axios.get(`${ apiPaths.CRM }/${ id }`);
  },
  index(query = '') {
    return axios.get(`${ apiPaths.CRM }${ query }`);
  },
  store(data) {
    return axios.post(`${ apiPaths.CRM }`, { crm: data });
  },
  getMasterCrm() {
    return axios.get(`${ apiPaths.CRM }/master-crm`);
  },
  restore({ id }) {
    return axios.post(`${ apiPaths.CRM }/${ id }/restore`);
  },
};
